import { supabase } from '@/config/supabase';
import store from '@/store';

/**
 * Track user journey event by calling Supabase RPC directly
 * @param {string} event_type - Type of event (e.g., 'quick_scan_added', 'recurring_scan_added', 'scan_deleted', 'scan_edited', 'scan_duplicated')
 * @param {Object} event_data - Event-specific data (optional)
 */
export async function trackUserJourney(event_type, event_data = null) {
  try {


    // Get user from Vuex store (more reliable than getSession in some contexts)
    const user = store.state.auth.user;

    if (!user || !user.id) {
      // Fallback: Try to get session from Supabase directly
      const { data: { session: supabaseSession } } = await supabase.auth.getSession();

      if (!supabaseSession || !supabaseSession.user) {

        return;
      }

      // Use Supabase session user


      // Call Supabase RPC function
      const result = await supabase.rpc('record_user_journey', {
        p_user_id: supabaseSession.user.id,
        p_event_type: event_type,
        p_product_name: 'gridtracker',
        p_feature_name: null,
        p_event_data: event_data,
        p_utm_source: null,
        p_utm_medium: null,
        p_session_id: null
      });

      return;
    }



    // Call Supabase RPC function with user from store
    const result = await supabase.rpc('record_user_journey', {
      p_user_id: user.id,
      p_event_type: event_type,
      p_product_name: 'gridtracker',
      p_feature_name: null,
      p_event_data: event_data,
      p_utm_source: null,
      p_utm_medium: null,
      p_session_id: null
    });

  

    if (result.error) {
      console.error('[User Journey] Error tracking:', result.error);
    } else {
 
    }
  } catch (error) {

    // Don't throw error to prevent disrupting user flow
  }
}
